import React from 'react';
import { View, TouchableOpacity, Dimensions, ScrollView } from 'react-native';
import { Text } from 'react-native-elements';
import Modal from 'modal-enhanced-react-native-web';

import Colors from '../../../constants/Colorsv2';


const { width, height } = Dimensions.get('screen');

import { ActivityActionModalProps } from '../../../types';
import Styles from '../../../constants/Styles';


function ActivityActionModal({ isVisible, closeModal, actions, actionTaken, scroll } : ActivityActionModalProps){
    const renderActions = (action: any, index:number) => {
        return (
            <TouchableOpacity key={`${index}:${action.type}`} style={styles.actionSectionStyle} onPress={() => {
                actionTaken(action.type)
                closeModal() 
            }}>
                <Text style={[Styles.textStyles.blackRegularCenter16, { color: action.color?action.color:Colors.shades.black }]}>{action.label}</Text>
            </TouchableOpacity>
        )
    }
    
    return (
        <Modal isVisible={isVisible} style={{ flex:1, margin:0, justifyContent: 'flex-end', alignItems:'center'}} animationIn='slideInUp' animationOut='slideOutDown' animationOutTiming={400}
        onSwipeComplete={() => closeModal()} onBackdropPress={() => closeModal()} >
            {scroll ?
            <ScrollView style={[styles.modalStyle, { marginTop:25 }]}>
                <TouchableOpacity style={styles.actionSectionStyle} onPress={() => closeModal() }>
                        <Text style={[Styles.textStyles.blackRegularCenter16, { color: Colors.utility.error }]}>CLOSE</Text>
                    </TouchableOpacity>
                {actions.map((a,i) => {
                    return renderActions(a,i)
                })}
            </ScrollView>
            :
            <View style={styles.modalStyle}>
                {actions.map((a,i) => {
                    return renderActions(a,i)
                })}
            </View>
            }
        </Modal>
    )
}

const styles = {
    modalStyle: { width:width>800?800:width, backgroundColor: Colors.shades.white, borderTopRightRadius: 15, borderTopLeftRadius: 15, paddingBottom:35 },
    actionSectionStyle: { paddingTop:24, paddingBottom:24, justifyContent:'center', alignItems:'center', borderBottomWidth:1, borderBottomColor:Colors.shades.shade400 },
    actionTextStyle: { fontSize:14, textAlign:'center', fontFamily: 'roboto-regular' }
}

export default ActivityActionModal